  
    <div class="ui-dialog-content ui-g-12">
      <div [kv-form-element]="{label: 'card.domiciliation_current_store', md: '12'}">
        {{currentStore.code}} - {{currentStore.name}}
      </div>
      <div [kv-form-element]="{label: 'card.domiciliation_select_channel', md: '12'}">
        <p-dropdown [(ngModel)]="selectedChannel" (onChange)="getStoresByChannel()" [options]="channels" [filter]="true" placeholder="Seleziona..."></p-dropdown>
      </div>
      <div [kv-form-element]="{label: 'card.domiciliation_select_store', md: '12'}">
        <p-dropdown [(ngModel)]="selectedStore" [options]="filteredStoresListItem" [filter]="true" placeholder="Seleziona..."></p-dropdown>
      </div>
    </div>
    <div class="ui-dialog-footer">
      <button type="button" [ngClass]="{'btnDisabled' : !selectedStore || !selectedChannel}" [disabled]="!selectedStore || !selectedChannel" pButton class="ui-button-success btnDelete" icon="fa fa-retweet" iconPos="left" (click)="this.onSave.emit(this.selectedStore)" label="{{'common.save' | translate}}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left" (click)="this.onCancel.emit()" label="{{'common.cancel' | translate}}"></button>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/card-domiciliation.component.ts.CardDomiciliationComponent.html